// =============================================================================
// Trilha de auditoria — eventos por solicitacao
// =============================================================================
// Helper fino sobre a RPC nf.log_solicitacao_evento. Best-effort: erros
// nao bloqueiam o fluxo principal (chamar via .catch() ou await sem try
// fora). O timestamp e ator_email sao preenchidos pelo banco.
// =============================================================================

import { supabase } from './supabase';

// Tipos de evento conhecidos. Mantem como constantes pra evitar typo.
export const EVENTOS = {
  CRIADA:                   'criada',
  EDITADA:                  'editada',
  STATUS_ALTERADO:          'status_alterado',
  NF_ANEXADA:               'nf_anexada',
  ESPELHO_ENVIADO_MAILTO:   'espelho_enviado_mailto',
  ESPELHO_ENVIADO_SERVIDOR: 'espelho_enviado_servidor',
  NF_EMITIDA_ENVIADA:       'nf_emitida_enviada',
  ESPELHO_APROVADO:         'espelho_aprovado',         // logado server-side
  ESPELHO_RECUSADO:         'espelho_recusado',         // logado server-side
  NF_RECEBIDA_CONFIRMADA:   'nf_recebida_confirmada',   // logado server-side
  // Lembretes automaticos enviados pelo cron job /api/cron/send-reminders
  // (a cada 2 dias sem resposta; max 2 reminders por solicitacao).
  LEMBRETE_ESPELHO_ENVIADO:        'lembrete_espelho_enviado',
  LEMBRETE_NF_RECEBIMENTO_ENVIADO: 'lembrete_nf_recebimento_enviado',
};

/**
 * Registra um evento de auditoria pra uma solicitacao.
 *
 * @param {string} solicitacaoId - uuid da solicitacao
 * @param {string} evento        - chave de EVENTOS ou string livre
 * @param {object} [detalhes]    - payload jsonb (status_antes/depois, motivo, etc)
 * @returns {Promise<object|null>} a row inserida, ou null em caso de erro
 */
export async function logEvento(solicitacaoId, evento, detalhes = null) {
  if (!solicitacaoId || !evento) return null;
  try {
    const { data, error } = await supabase
      .schema('nf')
      .rpc('log_solicitacao_evento', {
        p_solicitacao_id: solicitacaoId,
        p_evento: evento,
        p_detalhes: detalhes,
      });
    if (error) {
      console.warn('[audit] falha ao logar evento', evento, error);
      return null;
    }
    return data;
  } catch (err) {
    console.warn('[audit] excecao ao logar evento', evento, err);
    return null;
  }
}
